export function unique(array: string[]): string[] {
  return array.filter((v, i, a) => a.indexOf(v) === i);
}
